<template>
  <div id="validation">
    <el-form v-if="validationForm" :rules="validationFormRules" :model="validationForm" :inline="true" ref="appForm"
      label-position="top" label-width="160px" @submit.native.prevent>
      <template v-for="(item, index) of validationCondition">
        <div v-if="item.type === 'hidden'" :key="index" class="hidden-item">
          <el-form-item :prop="item.key">
            <el-input type="hidden" v-model="validationForm[item.key]"></el-input>
          </el-form-item>
        </div>
        <div :class="`custom_${item.key}`" v-if="item.type === 'input' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <template slot="label">
              <div class="form-item-label">
                <el-radio-group v-if="item.isChecked" v-model="item.checked" @change="item.onCheckboxChange">
                  <el-radio class="checkbox" :label="true">
                    <span>{{ `${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}` }}</span>
                  </el-radio>
                </el-radio-group>
                <span v-if="!item.isChecked">
                  {{ `${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}` }}
                  <span v-if="item.tipList && item.tipList.length">
                    <el-popover :placement="'right'" :visible-arrow="false" trigger="click" theme="dark">
                      <i class="iconfont icon-wenhao" slot="reference"></i>
                      <div class="tips-label-box">
                        <p v-for="(tip, i) of item.tipList" :key="i" class="tips-label-item">
                          <span v-if="tip.key" class="tips-label-key">{{ tip.key }}</span>
                          <span class="tips-label-value">{{ tip.value }}</span>
                        </p>
                      </div>
                    </el-popover>
                  </span>
                </span>
                <template v-if="item.example">
                  <span class="label-right" @click="handleExampleClick(item.example)">{{
                    $t('message.common.viewExamples') }}</span>
                </template>
              </div>
            </template>
            <template v-if="!item.isChecked || item.checked">
              <div v-if="item.description" class="el-form-item-desc">{{ $t(item.description) }}</div>
              <el-input :placeholder="item.placeholder ? $t(item.placeholder) : ''" :disabled.sync="!!item.isDisabled"
                v-model="validationForm[item.key]" :maxlength="item.maxLength" :size="size"
                @input="item.changeValue ? item.changeValue($event) : null">
                <template v-if="item.prepend">
                  <template slot="prepend">{{ item.prepend }}</template>
                </template>
              </el-input>
              <div v-if="item.bottomTips" class="el-form-bottom-tips">{{ item.bottomTips }}</div>
            </template>
          </el-form-item>
        </div>
        <!-- 编辑input -->
        <div v-if="item.type === 'editinput' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <template slot="label">
              <div class="form-item-label">
                <span>{{ `${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}` }}</span>
                <template v-if="item.example">
                  <span class="label-right" @click="handleExampleClick(item.example)">{{
                    $t('message.common.viewExamples') }}</span>
                </template>
              </div>
            </template>
            <div v-if="item.description" class="el-form-item-desc">{{ $t(item.description) }}</div>
            <rhcn-input v-model="validationForm[item.key]" :class="`${item.key}-form-input`"
              :disabled.sync="!!item.isDisabled" :maxlength="item.maxLength" suffix="edit"
              @input="item.changeValue ? item.changeValue($event) : null"
              :placeholder="item.placeholder ? $t(item.placeholder) : ''">
              <span style="color:#264373;" class="iconfont icon-shougongchuli" slot="suffix"
                @click="inputEditClick(`${item.key}-form-input`)"></span>
            </rhcn-input>
          </el-form-item>
        </div>
        <!-- 密码 -->
        <div v-if="item.type === 'password' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : $t('message.common.optional')}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <el-input :placeholder="item.placeholder ? $t(item.placeholder) : ''" :disabled="item.isDisabled"
              show-password v-model="validationForm[item.key]" class="password-input"></el-input>
          </el-form-item>
        </div>
        <div v-if="item.type === 'checkbox' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <el-checkbox v-model="validationForm[item.key]" @change="item.onChange"></el-checkbox>
            <span v-if="item.placeholder" class="checkbox-placeholder">{{ $t(item.placeholder) }}</span>
          </el-form-item>
        </div>
        <div v-if="item.type === 'radio' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <el-radio-group v-model="validationForm[item.key]">
              <el-radio v-for="(p, i) of item.options" :key="i + ''" :label="p.value">
                {{ item.isInternationalization ? $t(p.label) : p.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-if="item.type === 'radio_group' && !item.isHide" :key="index" :class="item.key">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <el-radio-group v-model="validationForm[item.key]" @change="item.onValueChange">
              <el-radio-button v-for="(p, i) of item.options" :key="i + ''" :label="p.value">
                {{ item.isInternationalization ? $t(p.label) : p.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <div v-if="item.type === 'date_time' && !item.isHide" :key="index"
          :class="{ 'date_time-picker-wrapper': item.useWrapperClass }">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <template slot="label">
              <div class="form-item-label"
                style="display: flex;align-items: center;justify-content: flex-start;gap: 10px;">
                <span>{{ `${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}` }}</span>
                <span v-if="item.tipList && item.tipList.length">
                  <el-popover :placement="'right'" :visible-arrow="false" trigger="hover" theme="dark">
                    <img style="width: 16px; height: 16px;position: relative;top: 4px;"
                      src="@/assets/image/common/tool_Info.png" alt="" slot="reference">
                    <div class="tips-label-box">
                      <p v-for="(tip, i) of item.tipList" :key="i" class="tips-label-item">
                        <span v-if="tip.key" class="tips-label-key">{{ tip.key }}</span>
                        <span class="tips-label-value">{{ tip.value }}</span>
                      </p>
                    </div>
                  </el-popover>
                </span>
              </div>
            </template>
            <!-- 对外暴露值 -->
            <slot name="noExpiration">
              <!-- <el-checkbox v-model="noExpiration">{{ $t('message.risk.noExpiration') }}</el-checkbox> -->
            </slot>
            <RhcnDatepicker :disabled="item.isDisabled" v-model="validationForm[item.key]"
              :type="item.dateType || 'datetime'" :format="item.dateFormat || 'yyyy-MM-dd HH:mm:ss'"
              :value-format="item.dateValueFormat" popper-class="date-picker-class"
              :placeholder="item.placeholder ? $t(item.placeholder) : ''" :picker-options="item.pickerOptions"
              @change="item.changeValue ? item.changeValue($event) : null">
            </RhcnDatepicker>
            <!-- 临时添加 后续移除。封版前时间紧张 黑色 2025-04-18 -->

            <div style="
                font-family: 'Open Sans-regular';
                font-weight: 400;
                font-size: 12px;
                color: #8D98AF;
                line-height: 16px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                margin-top: 8px;" class="date-picker-tips" v-if="item.datePickerTips">
              {{ item.datePickerTips }}
            </div>
          </el-form-item>
        </div>
        <div v-if="item.type === 'select' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <template v-if="item.tipList && item.tipList.length">
              <template slot="label">
                <div class="tips-label">
                  <span>{{ `${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}` }}</span>
                  <span>
                    <el-popover :placement="'right'" :visible-arrow="false" trigger="click">
                      <i class="iconfont icon-wenhao" slot="reference"></i>
                      <div class="tips-label-box">
                        <p v-for="(tip, i) of item.tipList" :key="i" class="tips-label-item">
                          <span class="tips-label-key">{{ tip.key }}</span>
                          <span class="tips-label-value">{{ tip.value }}</span>
                        </p>
                      </div>
                    </el-popover>
                  </span>
                </div>
              </template>
            </template>
            <div v-if="item.description" class="el-form-item-desc">{{ $t(item.description) }}</div>
            <el-select v-model="validationForm[item.key]" :disabled="item.isDisabled" filterable clearable
              :multiple="item.multiple" :multiple-limit="item.multipleLimit" :remote="item.remote"
              :loading="item.loading" :filter-method="item.filterMethod ? item.filterMethod : null"
              @change="item.changeValue ? item.changeValue($event) : null"
              :placeholder="item.placeholder ? $t(item.placeholder) : ''"
              :no-match-text="$t('message.common.noMatchText')"
              :no-data-text="item.noDataText ? $t(item.noDataText) : $t('message.common.noDataText')"
              :style="{ width: item.itemWidth ? item.itemWidth : '100%' }">
              <div v-if="!item.group">
                <el-option v-for="(p, i) of item.options" :key="i + ''"
                  :label="item.option ? p[item.option.label] : item.isInternationalization ? $t(p.label ? p.label : p.text) : p.label ? p.label : p.text"
                  :value="item.option ? p[item.option.value] : p.value">
                  <div class="rhcn-select-option">
                    <el-image v-if="item.withIcon" class="rhcn-select-option-icon" :src="p.icon"></el-image>
                    <span>{{ item.option ? p[item.option.label] :
                      item.isInternationalization ? $t(p.label ? p.label : p.text) : p.label ? p.label : p.text
                      }}</span>
                  </div>
                </el-option>
              </div>
              <div v-else>
                <el-option-group v-for="group in item.options" :key="group.label"
                  :label="item.isInternationalization ? $t(group.label) : group.label">
                  <el-option v-for="(p, i) of group.options" :key="i + ''"
                    :label="item.option ? p[item.option.label] : item.isInternationalization ? $t(p.label ? p.label : p.text) : p.label ? p.label : p.text"
                    :value="item.option ? p[item.option.value] : p.value">
                    <div class="rhcn-select-option">
                      <el-image v-if="item.withIcon" class="rhcn-select-option-icon" :src="p.icon"></el-image>
                      <span>{{ item.option ? p[item.option.label] :
                        item.isInternationalization ? $t(p.label ? p.label : p.text) : p.label ? p.label : p.text
                        }}</span>
                    </div>
                  </el-option>
                </el-option-group>
              </div>

            </el-select>
          </el-form-item>
        </div>
        <div v-if="item.type === 'dropdown-select' && !item.isHide" :key="index">
          <el-form-item :style="{ width: inputWidth }" :prop="item.key">
            <template slot="label">
              <span>{{ `${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}` }}</span>
              <template v-if="item.description">
                <el-popover trigger="hover" class="i-popover" placement="right">
                  <div v-html="$t(item.description)"></div>
                  <span class="iconfont icon-tishi003" slot="reference"></span>
                </el-popover>
              </template>
            </template>
            <rhcn-select-dropdown v-model="validationForm[item.key]" :options="item.options"
              :placeholder="item.placeholder ? $t(item.placeholder) : ''" :size="size"></rhcn-select-dropdown>
          </el-form-item>
        </div>
        <div v-if="item.type === 'continuity_select_input' && !item.isHide" :key="index">
          <div class="form-multiple-child-wrap">
            <template v-for="(subItem, subIndex) of item.subCondition">
              <div class="form-multiple-child" v-if="subItem.type === 'input' && !subItem.isHide" :key="subIndex">
                <el-form-item
                  :label="`${$t(subItem.name)} ${subItem.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
                  :style="{ width: inputWidth }" :prop="subItem.key">
                  <template v-if="subItem.tipList && subItem.tipList.length">
                    <template slot="label">
                      <div class="tips-label">
                        <span>{{ `${$t(subItem.name)} ${subItem.isShowStar ? '' :
                          `(${$t('message.common.optional')})`}` }}</span>
                        <span>
                          <el-popover :placement="'right'" :visible-arrow="false" trigger="click">
                            <i class="iconfont icon-wenhao" slot="reference"></i>
                            <div class="tips-label-box">
                              <p v-for="(tip, i) of subItem.tipList" :key="i" class="tips-label-item">
                                <span class="tips-label-key">{{ tip.key }}</span>
                                <span class="tips-label-value">{{ tip.value }}</span>
                              </p>
                            </div>
                          </el-popover>
                        </span>
                      </div>
                    </template>
                  </template>
                  <el-input :placeholder="subItem.placeholder ? $t(subItem.placeholder) : ''"
                    :disabled="subItem.isDisabled" v-model="validationForm[subItem.key]"
                    @input="subItem.changeValue ? subItem.changeValue($event) : null"></el-input>
                </el-form-item>
              </div>
              <div class="form-multiple-child" v-if="subItem.type === 'select' && !subItem.isHide" :key="subIndex">
                <el-form-item
                  :label="`${$t(subItem.name)} ${subItem.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
                  :style="{ width: inputWidth }" :prop="subItem.key">
                  <el-select v-model="validationForm[subItem.key]" :disabled="subItem.isDisabled" filterable clearable
                    @change="subItem.changeValue ? subItem.changeValue($event) : null"
                    :placeholder="subItem.placeholder ? $t(subItem.placeholder) : ''" style="width: 100%;">
                    <el-option v-for="(p, i) of subItem.options" :key="i + ''"
                      :label="subItem.isInternationalization ? $t(p.label ? p.label : p.text) : p.label ? p.label : p.text"
                      :value="p.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="form-multiple-child" v-if="subItem.type === 'date' && !subItem.isHide" :key="subIndex">
                <el-form-item
                  :label="`${$t(subItem.name)} ${subItem.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
                  :style="{ width: inputWidth }" :prop="subItem.key">
                  <el-date-picker v-model="validationForm[subItem.key]" :disabled="subItem.isDisabled" type="date"
                    :picker-options="subItem.pickerOptions && subItem.pickerOptions">
                  </el-date-picker>
                </el-form-item>
              </div>
            </template>
          </div>
        </div>
        <div v-if="item.type === 'textarea' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <template slot="label">
              <div class="form-item-label form-item-label-textarea" style="align-items: flex-end !important;">
                <span>{{ `${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}` }}</span>
                <span v-if="item.tipList && item.tipList.length">
                  <el-popover :placement="'left'" :visible-arrow="false" trigger="hover" theme="dark">
                    <!-- <i class="iconfont icon-wenhao" slot="reference"></i> -->
                    <!--  src="@/assets/image/common/tool_Info.png" -->
                    <img style="width: 16px; height: 16px;position: relative;top: 4px;"
                      src="@/assets/image/common/tool_Info.png" alt="" slot="reference">
                    <div class="tips-label-box">
                      <p v-for="(tip, i) of item.tipList" :key="i" class="tips-label-item">
                        <span v-if="tip.key" class="tips-label-key">{{ tip.key }}</span>
                        <span class="tips-label-value">{{ tip.value }}</span>
                      </p>
                    </div>
                  </el-popover>
                </span>
              </div>
            </template>
            <el-input type="textarea" :rows="item.rows || 3" :disabled="item.isDisabled"
              :placeholder="getTextareaPlaceholder(item)" v-model="validationForm[item.key]"></el-input>
          </el-form-item>
        </div>
        <div v-if="item.type === 'upload_image' && !item.isHide" :key="index">
          <el-form-item v-if="item.uploadRange" :label="$t(item.name)"
            :class="{ 'va-star': item.isShowStar, 'va-star-hide': !item.isShowStar }" :style="{ width: inputWidth }"
            :prop="item.key">
            <el-upload action="#" list-type="picture-card"
              :class="{ 'va-picture-card-s': true, 'va-picture-card': item.uploadRange.uploadFileList.length >= (item.uploadRange.limit ? item.uploadRange.limit : 1) }"
              :on-change="uploadChange(item, item.uploadRange)"
              :limit="item.uploadRange && item.uploadRange.limit ? item.uploadRange.limit : 1"
              :disabled="item.isDisabled" :file-list="item.uploadRange.uploadFileList" :auto-upload="false">
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}" class="file-content" :title="file.name">
                <img v-if="item.uploadRange && !item.uploadRange.isFile" class="upload-fixed-image" :src="file.url"
                  alt="">
                <div v-if="item.uploadRange && item.uploadRange.isFile && file.status == 'successDone'"
                  class="file-content">
                  <!--                  <i class="el-icon-success"-->
                  <!--                     style="color: greenyellow;-->
                  <!--                     height: 100%;-->
                  <!--                     width: 100%;-->
                  <!--                     text-align: right;-->
                  <!--                     font-size: 40px;"></i>-->
                  <img src="../../assets/image/pdf.svg" alt="file">
                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(item.uploadRange, file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <!--        <span-->
                    <!--          v-if="!disabled"-->
                    <!--          class="el-upload-list__item-delete"-->
                    <!--          @click="handleDownload(file)"-->
                    <!--        >-->
                    <!--          <i class="el-icon-download"></i>-->
                    <!--        </span>-->
                    <span class="el-upload-list__item-delete" @click="handlePictureCardRemove(item.uploadRange, file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </div>
            </el-upload>
          </el-form-item>
        </div>
        <div v-if="item.type === 'upload_fixed_image' && !item.isHide" :key="index">
          <el-form-item v-if="item.uploadRange"
            :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <div class="upload-fixed-image-wrap" v-for="(imageItem, imageIndex) of item.uploadRange" :key="imageIndex">
              <el-upload action="#" list-type="picture-card"
                :class="{ 'va-picture-card': imageItem.uploadFileList.length >= (imageItem.limit ? imageItem.limit : 1) }"
                :on-change="uploadChange(item, imageItem)" :limit="imageItem && imageItem.limit ? imageItem.limit : 1"
                :disabled="item.isDisabled" :file-list="imageItem.uploadFileList" :auto-upload="false">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}" class="file-content" :title="file.name">
                  <img v-if="imageItem && !imageItem.isFile" class="upload-fixed-image" :src="file.url" alt="">
                  <div v-if="imageItem && imageItem.isFile && file.status == 'successDone'" class="file-content">
                    <img src="../../assets/image/pdf.svg" alt="file">
                  </div>
                  <div v-if="imageItem.isDisplayIcon">
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(imageItem, file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span class="el-upload-list__item-delete"
                        @click="handlePictureCardRemove(imageItem, file, $event)">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </div>
                <div slot="tip" class="el-upload__tip">{{ $t(imageItem.fileLongDisplayTips) }}</div>
              </el-upload>
            </div>
          </el-form-item>
        </div>
        <div v-if="item.type === 'upload_file' && !item.isHide" :key="index">
          <el-form-item v-if="item.uploadRange"
            :label="`${$t(item.name)} ${item.isShowStar ? '' : $t('message.common.optional')}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <template slot="label">
              <div class="form-item-label">
                <div>
                  <span>{{ `${$t(item.name)} ${item.isShowStar ? '' : $t('message.common.optional')}` }}</span>
                  <template v-if="item.uploadRange && item.uploadRange.templateFileName">
                    <a :href="item.uploadRange.templateFileName"
                      :download="item.uploadRange.templateFileNameShow || item.uploadRange.templateFileName"
                      class="download-template">*{{ $t('message.common.downloadTemplate') }}</a>
                  </template>
                  <template v-if="item.uploadRange && item.uploadRange.status">
                    <span class="upload-status" v-html="item.uploadRange.status(item)"></span>
                  </template>
                </div>
                <template v-if="item.example">
                  <span class="label-right" @click="handleExampleClick(item.example)">{{
                    $t('message.common.viewExamples') }}</span>
                </template>
              </div>
            </template>
            <div class="upload-position">
              <rhcn-upload :tip="item.uploadRange.fileTypeRuleTipsShow" :file-list="item.uploadRange.uploadFileList"
                :disabled="item.isDisabled" :accept="item.uploadRange.fileTypeRule"
                :upload-tips="item.uploadRange && item.uploadRange.uploadTips ? item.uploadRange.uploadTips : ''"
                :limit="item.uploadRange && item.uploadRange.limit ? item.uploadRange.limit : 1"
                :fileSize="item.uploadRange && item.uploadRange.fileSize ? item.uploadRange.fileSize : 5"
                :on-change="uploadChange(item, item.uploadRange)"
                :on-remove="uploadRemove(item, item.uploadRange)"></rhcn-upload>
              <span v-if="item.uploadRange && item.uploadRange.uploadFileTips" class="upload-file-tips">{{
                item.uploadRange.uploadFileTips }}</span>
            </div>
          </el-form-item>
          <!-- <div v-if="item.isShowprogress">
              <el-progress :percentage="50"></el-progress>
          </div> -->
        </div>
        <div v-if="item.type === 'upload_file_v2' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <template slot="label">
              <div class="form-item-label" style="align-items: flex-end;">
                <div class="info-tips" v-if="item.infoTips && item.infoTips.length">
                  <div class="info-tips-item" v-for="(tip, index) of item.infoTips" :key="index">
                    {{ tip }}
                  </div>
                </div>
                <el-radio-group v-if="item.isChecked" v-model="item.checked" @change="item.onCheckboxChange">
                  <el-radio class="checkbox" :label="true">
                    <span>{{ `${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}` }}</span>
                  </el-radio>
                </el-radio-group>
                <span v-if="!item.isChecked">{{ `${$t(item.name)} ${item.isShowStar ? '' :
                  `(${$t('message.common.optional')})`}` }}</span>
                <template v-if="item.uploadRange && item.uploadRange.templateFileName">
                  <a :href="item.uploadRange.templateFileName"
                    :download="item.uploadRange.templateFileNameShow || item.uploadRange.templateFileName" :style="{
                      marginBottom: item.infoTips && item.infoTips.length ? '24px' : 0,
                    }" class="download-template upload_file_v2">
                    <img class="download-template-icon" src="@/assets/image/icon-down.png" alt="download" />
                    {{
                      $t('message.common.downloadTemplate') }}
                  </a>

                </template>
                <template v-if="item.example">
                  <span class="label-right" @click="handleExampleClick(item.example)">{{
                    $t('message.common.viewExamples') }}</span>
                </template>
              </div>
            </template>
            <template v-if="!item.isChecked || item.checked">
              <div v-if="item.description" class="el-form-item-desc">{{ $t(item.description) }}</div>
              <RhcnUploadV2 :file-list="item.uploadRange.uploadFileList" :disabled="item.isDisabled"
                :accept="item.uploadRange.fileTypeRule" :on-change="uploadChange(item, item.uploadRange)"
                :on-remove="uploadRemove(item, item.uploadRange)">
              </RhcnUploadV2>
            </template>
          </el-form-item>
        </div>
        <div v-if="item.type === 'color-picker' && !item.isHide" :key="index">
          <!-- <el-color-picker v-model="validationForm[item.key]"></el-color-picker> -->
          <el-form-item :label="$t(item.name)" :class="{ 'va-star': item.isShowStar, 'va-star-hide': !item.isShowStar }"
            :style="{ width: inputWidth }" :prop="item.key">
            <div>
              <div class="rhcn-color-picker" @click="colorInputFocus($event, item.key)">
                <el-color-picker size="small" @change="colorChangeHandler($event, item.key, item)"
                  v-model="validationForm[item.key]" color-format="rgb"></el-color-picker>
                <div class="rhcn-color-picker-input" :class="[size]">
                  <el-input :size="size" type="text" v-model="validationForm[`${item.key}Color`]"
                    @change="colorInputChange($event, item.key, item)">
                    <template slot="prefix">
                      <span>#</span>
                    </template>
                  </el-input>
                </div>
              </div>
              <div v-if="item.placeholder" class="color-picker-tips">{{ $t(item.placeholder) }}</div>
            </div>
          </el-form-item>
        </div>
        <div v-if="item.type === 'cascader' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <RhcnCascader :value.sync="validationForm[item.key]" :options="item.options"
              @change="item.changeValue ? item.changeValue($event) : null"></RhcnCascader>
          </el-form-item>
        </div>
        <div v-if="item.type === 'slot' && !item.isHide" :key="index">
          <el-form-item :label="`${$t(item.name)} ${item.isShowStar ? '' : `(${$t('message.common.optional')})`}`"
            :style="{ width: inputWidth }" :prop="item.key">
            <div v-if="item.description" class="el-form-item-desc">{{ $t(item.description) }}</div>
            <slot :name="item.key"></slot>
          </el-form-item>
        </div>
      </template>
    </el-form>
    <el-dialog width="30%" :visible.sync="imageDisplayKey" :modal-append-to-body="false">
      <img width="100%" :src="imageURL" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { Loading } from 'element-ui';

import RhcnCascader from '@/components/form/cascader.vue';
import RhcnDatepicker from '@/components/form/datepicker.vue';
import RhcnInput from '@/components/form/input.vue';
import RhcnSelectDropdown from '@/components/form/select-dropdown.vue';
import RhcnUploadV2 from '@/components/form/upload-v2.vue';
import RhcnUpload from '@/components/form/upload.vue';
import { ShowErrorMessage, ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { validateFns } from '@/components/validation/tool/validator';
import { formatDateDisplay } from '@/utils/tools/time';
import { shallowClones, isImage, RGBToHex } from '@/utils/tools/utils';
export default {
  name: 'ValidationComponent',
  components: {
    RhcnUpload,
    RhcnInput,
    RhcnUploadV2,
    RhcnDatepicker,
    RhcnCascader,
    RhcnSelectDropdown,
  },
  props: {
    validationCondition: {
      type: Array,
      default: () => [],
    },
    inputWidth: {
      type: String,
      default: '100%',
    },
    size: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      validationFormRules: {},
      validationForm: {},
      imageDisplayKey: false,
      imageURL: '',
      originalSaveCondition: [],
      noExpiration: true,
    };
  },
  methods: {
    initForm() {
      const obj = {};
      this.originalSaveCondition = shallowClones(this.validationCondition);
      this.validationCondition.forEach((item) => {
        if (item.type === 'continuity_select_input') {
          item.subCondition.forEach(subItem => {
            obj[subItem.key] = subItem.defValue;
            subItem.isDisabled = !!subItem.isDisabled;
            subItem.isHide = !!subItem.isHide;
            if (subItem.rule) {
              this.validationFormRules[subItem.key] = [
                { validator: validateFns(subItem.rule), trigger: 'change' },
              ];
            }
            if (subItem.validator) {
              this.validationFormRules[subItem.key].push({ validator: subItem.validator, trigger: 'change' });
            }
          });
        } else {
          obj[item.key] = item.defValue || '';
          if (item.type === 'color-picker') {
            obj[`${item.key}Color`] = item.defValue.replace('#', '');
          }
          item.isDisabled = !!item.isDisabled;
          item.isHide = !!item.isHide;
          if (item.rule) {
            this.validationFormRules[item.key] = [
              { validator: validateFns(item.rule), trigger: 'change' },
            ];
          }
          if (item.validator) {
            this.validationFormRules[item.key].push({ validator: item.validator, trigger: 'change' });
          }
        }
      });
      return obj;
    },
    // 添加一个表单项
    addItem(item) {
      this.validationCondition.push(item);
      this.originalSaveCondition = shallowClones(this.validationCondition);
      if (item.type === 'continuity_select_input') {
        item.subCondition.forEach(subItem => {
          this.$set(this.validationForm, subItem.key, subItem.defValue);
          subItem.isDisabled = !!subItem.isDisabled;
          subItem.isHide = !!subItem.isHide;
          if (subItem.rule) {
            this.validationFormRules[subItem.key] = [
              { validator: validateFns(subItem.rule), trigger: 'change' },
            ];
          }
          if (subItem.validator) {
            this.validationFormRules[subItem.key].push({ validator: subItem.validator, trigger: 'change' });
          }
        });
      } else {
        this.$set(this.validationForm, item.key, item.defValue);
        item.isDisabled = !!item.isDisabled;
        item.isHide = !!item.isHide;
        if (item.rule) {
          this.$set(this.validationFormRules, item.key, [{ validator: validateFns(item.rule), trigger: 'change' }]);
        }
        if (item.validator) {
          this.validationFormRules[item.key].push({ validator: item.validator, trigger: 'change' });
        }
      }
    },
    // 删除一个表单项
    removeItem(key) {
      let index = -1;
      for (let i = 0; i < this.validationCondition.length; i++) {
        const item = this.validationCondition[i];
        if (item.key === key) {
          index = i;
          break;
        }
      }
      if (index > -1) {
        this.validationCondition.splice(index, 1);
      }
      delete this.validationFormRules[key];
      delete this.validationForm[key];
      this.originalSaveCondition = shallowClones(this.validationCondition);
    },
    /**
     * 设置单一条目的值
     *  key:condition.key
     *  value:要设置的值(最好是string)
     */
    setItemValue(key, value, type = '') {
      this.validationForm[key] = value;
      if (type === 'color-picker') {
        this.validationForm[`${key}Color`] = value.replace('#', '');
      }
    },
    /**
     * 获取单一条目的值
     */
    getItemValue(key) {
      return this.validationForm[key];
    },
    /**
     * 获取表整个表单的值
     */
    getFormJson() {
      return shallowClones(this.validationForm);
    },
    /**
     * 重置表单
     */
    formReset() {
      if (this.originalSaveCondition) {
        this.originalSaveCondition.forEach((item) => {
          if (item.type === 'upload_file' || item.type === 'upload_file_v2') { // 文件上传
            this.setItemValue(`${item.key}Show`, ''); // upload file 显示选择的文件名
            this.setItemValue(`${item.key}File`, ''); // upload file 选择的文件
          }
        });
      }
      this.$refs.appForm.resetFields();
    },
    /**
     *  验证表单
     */
    toFormValid(validCallBack, errorCallBack) {
      this.$refs.appForm.validate((valid) => {
        if (valid) {
          if (validCallBack) {
            validCallBack(this.getFormJson());
          }
          return true;
        }
        if (errorCallBack) {
          errorCallBack(this.getFormJson());
        }
        return false;
      });
    },
    async validateAsync() {
      try {
        const res = await this.$refs.appForm.validate();
        return res;
      } catch (err) {
        //
      }
      return false;
    },
    /**
     * 获取条件列表中单一一个条目
     */
    getValidationItem(key) {
      let conditionItem = null;
      this.validationCondition.forEach((item) => {
        if (item.type === 'continuity_select_input') {
          item.subCondition.forEach(subItem => {
            if (subItem.key === key) {
              conditionItem = subItem;
            }
          });
        } else {
          if (item.key === key) {
            conditionItem = item;
          }
        }
      });
      return conditionItem;
    },
    /**
     * 通过网络获取选择框的值
     */
    setValidationSelectOptions(key, array) {
      this.getValidationItem(key).options = array;
      this.$forceUpdate();
    },
    /**
     * 赋值初始化
     */
    assignmentFormValue(data) {
      if (data) {
        Object.keys(data).forEach((item) => {
          if (this.getValidationItem(item)) {
            this.setItemValue(item, data[item]);
          }
        });
      }
    },
    /**
     * 设置Item不可点击
     */
    setItemDisabled(key, disabled, isAll) {
      if (isAll) {
        Object.keys(this.validationForm).forEach(item => {
          this.getValidationItem(item).isDisabled = disabled;
        });
      } else {
        this.getValidationItem(key).isDisabled = disabled;
      }
      this.$forceUpdate();
    },
    setItemName(key, name) {
      this.getValidationItem(key).name = name;
      this.$forceUpdate();
    },
    /**
     * 设置Item显示隐藏
     */
    setItemHide(key, value) {
      this.getValidationItem(key).isHide = value;
      this.$forceUpdate();
    },
    /**
     * 设置Item的验证规则
     */
    setItemRule(key, value) {
      if (value) {
        delete this.validationForm[key];
        this.$refs.appForm.clearValidate(key);
      } else {
        this.validationForm[key] = '';
      }
      this.$forceUpdate();
    },
    /**
     * 更新验证规则
     */
    updateItemRule(key, rule) {
      if (rule) {
        this.$set(this.validationFormRules, key, [{ validator: validateFns(rule), trigger: 'change' }]);
      } else {
        this.validationFormRules[key] = [];
      }
      this.$refs.appForm.clearValidate(key);
    },
    /**
     * 更新验证规则
     */
    clearValidate(key) {
      if (key) {
        this.$refs.appForm.clearValidate(key);
      } else {
        this.$refs.appForm.clearValidate();
      }
      this.$forceUpdate();
    },
    /**
     * 设置 Item 是否必填
     */
    setItemRequire(key, require) {
      this.getValidationItem(key).isShowStar = require;
      this.$forceUpdate();
    },
    setItemNoDataText(key, text) {
      this.getValidationItem(key).noDataText = text || 'message.common.noDataText';
      this.$forceUpdate();
    },
    setItemLoading(key, loading) {
      this.getValidationItem(key).loading = loading;
      this.$forceUpdate();
    },
    /**
     * 上传文件时候
     */
    uploadChange(item, uploadRange) {
      return async (event, array) => {
        if (item && uploadRange) {
          // 这里是最后上传的时候再做判断也可以
          // if (!uploadRange.uploadFile) {
          //   ShowWarningMessage('请选择文件');
          // }
          let isFileAdopt = true;

          if (uploadRange.fileTypeRule) {
            // 文件后缀名验证
            const fileNameArray = event.raw.name.split('.');
            const ext = fileNameArray[fileNameArray.length - 1];
            const fileTypeRuleArray = uploadRange.fileTypeRule.split(',');

            let rightFileType = false;
            // 检查文件后缀
            for (let i = 0; i < fileTypeRuleArray.length; i++) {
              if (fileTypeRuleArray[i].trim().toLowerCase().indexOf(ext) > -1) {
                rightFileType = true;
                break;
              }
            }

            // 若文件后缀名不匹配，检查文件类型
            if (!rightFileType && uploadRange.fileTypeRule.indexOf(event.raw.type) === -1) {
              array.splice(array.length - 1, 1);
              ShowWarningMessage(this.$t(uploadRange.fileTypeRuleTips));
              isFileAdopt = false;
            } else if (uploadRange.fileRuleStrictByFileName) { // 如果开启了严格检查模式，则需要检查文件名
              // 先强制转小写
              const lowerFileType = event.raw.name.split('.').pop()?.toLowerCase();
              const lowerFileTypeRule = uploadRange.fileTypeRule.toLowerCase();
              if (!lowerFileTypeRule.includes(lowerFileType)) {
                array.splice(array.length - 1, 1);
                ShowWarningMessage(this.$t(uploadRange.fileTypeRuleTips));
                isFileAdopt = false;
              }
            }
          }
          let isLtM = event.size / 1024 / 1024 < uploadRange.fileSize;
          if (uploadRange.fileSizeUnit) {
            isLtM = event.size / 1024 < uploadRange.fileSize;
          }
          if (!isLtM && isFileAdopt) {
            array.splice(array.length - 1, 1);
            const fileSizeUnit = uploadRange.fileSizeUnit ? uploadRange.fileSizeUnit : 'm';
            const fileSizeTips = `${this.$t('message.validator.fileCannot')}${uploadRange.fileSize}${fileSizeUnit}`;
            ShowWarningMessage(fileSizeTips);
            isFileAdopt = false;
          }
          if (uploadRange.fileUploadFunc && isFileAdopt) {
            // 主要是用于占位
            if (item.type === 'upload_fixed_image') {
              uploadRange.isDisplayIcon = false;
              uploadRange.uploadFileList.push({
                name: event.name,
                uid: event.uid,
                url: event.url,
                raw: event.raw,
              });
            }
            const uploadLoading = Loading.service();
            uploadRange.fileUploadFunc(event.raw).then(async (data) => {
              !uploadRange.hideSuccessMessage && ShowSuccessMessage(this.$t('message.uploadSuccessfulTip'));
              const param = {
                uid: event.uid,
                name: event.name,
                url: (data && data.fileUrl) ? data.fileUrl : data,
                originUrl: (data && data.fileUrl) ? data.fileUrl : data,
                uploadFileId: (data && data.fileId) ? data.fileId : data,
                status: 'successDone',
                size: event.size,
                uploadTime: formatDateDisplay(new Date(), 'yyyy MM.dd HH:mm:ss'),
                raw: event.raw,
              };
              if (uploadRange.fileUploadDisplayFunc) {
                await uploadRange.fileUploadDisplayFunc({ url: data }).then(item => {
                  param.url = item;
                });
              }
              if (item.type === 'upload_fixed_image') {
                uploadRange.isDisplayIcon = true;
                uploadRange.uploadFileList.splice(array.length - 1, 1);
              } else {
                this.validationForm[item.key] = [];
                this.validationForm[item.key].push(param);
              }
              uploadRange.uploadFileList.push(param);
              this.$forceUpdate();
              uploadLoading.close();
            }).catch(() => {
              array.splice(array.length - 1, 1);
              if (item.type === 'upload_fixed_image') {
                uploadRange.uploadFileList = array;
              }
              !uploadRange.hideErrorMessage && ShowErrorMessage(this.$t('message.uploadFailedTip'));
              uploadLoading.close();
            });
          } else {
            if (isFileAdopt) {
              uploadRange.uploadFileList.push({
                name: event.name,
                uid: event.uid,
                url: event.url,
                originUrl: event.url,
                size: event.size,
                uploadTime: formatDateDisplay(new Date(), 'yyyy MM.dd HH:mm:ss'),
                raw: event.raw,
              });
              if (uploadRange.fileChange) {
                uploadRange.fileChange(uploadRange.uploadFileList);
              }
            }
          }
          if (item.type === 'upload_file' || item.type === 'upload_file_v2') {
            this.validationForm[`${item.key}Show`] = event.raw.name;
            this.validationForm[`${item.key}File`] = event.raw;
            this.$forceUpdate();
          }
        }
        return false;
      };
    },
    uploadRemove(item, uploadRange) {
      return async (file, index) => {
        if (item && uploadRange) {
          uploadRange.uploadFileList.splice(index, 1);
          if (item && item.onRemove) {
            item.onRemove(uploadRange.uploadFileList);
          }
        }
      };
    },
    // 右侧上传按钮上传
    httpRequest(item) {
      return async (event) => {
        if (item.uploadRange.fileUploadFunc) {
          const loading = Loading.service();
          item.uploadRange.fileUploadFunc(event.file).then((data) => {
            loading.close();
            ShowSuccessMessage('上传成功');
            const fileList = item.uploadRange.uploadFileList;
            item.uploadRange.uploadFileList.push({
              uid: event.raw.uid,
              name: event.raw.name,
              status: 'done',
              url: data,
            });
          }).catch(() => {
            loading.close();
          });
        }
        return false;
      };
    },
    handlePictureCardRemove(uploadRange, file, event) {
      // 这里会用item.uploadRange.uploadFileList去找到file这个元素的下标,然后进行删除.
      if (file) {
        const index = uploadRange.uploadFileList.findIndex(item => item.uid === file.uid);
        uploadRange.uploadFileList.splice(index, 1);
        uploadRange.uploadFileList.splice(index, 1);
        if (uploadRange && uploadRange.fileRemoveFunc) {
          uploadRange.fileRemoveFunc(uploadRange, file);
        }
        if (uploadRange.fileChange) {
          uploadRange.fileChange(uploadRange.uploadFileList);
        }
      }
    },
    handlePictureCardPreview(uploadRange, file) {
      if (uploadRange && uploadRange.filePreviewFunc) {
        uploadRange.filePreviewFunc(uploadRange, file);
      } else {
        this.imageDisplayKey = true;
        this.imageURL = file.url;
      }
    },
    handleExampleClick(example) {
      if (example && example.func) {
        example.func(example.url);
      } else if (example.url) {
        if (isImage(example.url)) { // 图片为预览
          this.imageDisplayKey = true;
          this.imageURL = example.url;
        } else {
          window.location.href = example.url; // 不是图片则下载
        }
      }
    },
    inputEditClick(className) {
      document.querySelector(`.${className} input`).focus();
    },
    colorChangeHandler(value, key, item) {
      const hexValue = RGBToHex(value);
      this.validationForm[key] = hexValue;
      this.validationForm[`${key}Color`] = hexValue.replace('#', '');
      if (item.changeValue) {
        item.changeValue(hexValue);
      }
    },
    colorInputFocus(event) {
      const input = event.currentTarget.querySelector('.rhcn-color-picker-input .el-input__inner');
      if (input) {
        input.focus();
      }
    },
    colorInputChange(value, key, item) {
      if (/^([0-9a-f]{3}|[0-9a-f]{6})$/i.test(value)) {
        this.validationForm[key] = `#${value}`;
      } else {
        this.validationForm[key] = '';
        this.validationForm[`${key}Color`] = '';
      }
      if (item.changeValue) {
        item.changeValue(this.validationForm[key]);
      }
    },
    getTextareaPlaceholder(item) {
      if (!item.placeholder) return '';
      const placeholder = this.$t(item.placeholder);
      if (!item.example) return placeholder;
      return `${placeholder}\n${this.$t('message.risk.addBlackListItem.itemsDataPlaceholder.example')}\n${this.$t(item.example)}`;
    },
  },
  mounted() {
    this.$emit('afterViewInit');
  },
  created() {
    this.validationForm = this.initForm();
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

#validation {

  .date-picker-class,
  .rhcn-datepicker {
    width: 100%;

    .el-input__inner {
      text-align: left;
      padding-left: 12px;
    }
  }

  .el-input-group .el-input-group__prepend {
    border-color: transparent;
    margin-left: 2px;
    color: #606266;
  }

  .va-picture-card {
    .el-upload--picture-card {
      display: none;
    }
  }

  .va-star:before {
    content: '*';
    line-height: 38px;
    display: inline-block;
    padding-right: 4px;
    margin-top: 1px;
    color: $color-text-error;
  }

  .va-star-hide:before {
    content: '*';
    line-height: 38px;
    display: inline-block;
    padding-right: 4px;
    margin-top: 1px;
    color: red;
    display: none;
  }

  .file-content {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 96%;
    }
  }

  .hidden-item {
    height: 0;
    overflow: hidden;
  }

  .el-upload {
    width: 100%;

    .el-input__inner {
      cursor: pointer;
      background-color: $color-white;
      color: #606266;
    }
  }

  .va-picture-card-s {
    .el-upload {
      width: 148px;
    }
  }

  .file-type-tip {
    text-align: left;
  }

  .download-template {
    margin-left: 10px;
    font-weight: 600;

    &.upload_file_v2 {
      padding: 8px 24px;
      background: #FFFFFF;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #D0D5DD;
      font-size: 14px;
      color: #1A202C;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      text-transform: none;

      .download-template-icon {
        width: 14px;
        height: 14px;
        margin-right: 4px;
      }

      &:hover {
        background: rgba(26, 32, 44, 0.05);
      }
    }
  }

  .upload-status .status {
    margin-left: 13px;
    background-color: rgba(0, 162, 221, 0.2);
    font-size: 12px;
    color: $color-primary;
    height: 22px;
    line-height: 22px;
    padding: 0 10px;
    display: inline-block;
    border-radius: 4px;

    &.fail {
      background-color: rgba(255, 59, 65, 0.2);
      color: $color-icon-warn;
    }
  }

  .el-upload__tip {
    text-align: center;
  }

  .el-upload-list--picture-card {
    display: inline-block;
    height: 148px;
    // min-height: 148px;
  }

  .el-upload-list__item {
    transition: none;
  }

  .el-date-editor--date {
    width: 100%;
  }

  .upload-fixed-image-wrap {
    display: inline-block;
    margin-left: 20px;
    width: 148px;
    height: 195px;
    vertical-align: top;

    &:first-child {
      margin-left: 0;
    }

    .is-ready {
      display: none;
    }
  }

  .upload-fixed-image {
    width: 90%;
    height: 90%;
  }

  .form-multiple-child-wrap {
    display: flex;
    justify-content: space-between;
  }

  .form-multiple-child {
    flex: 1;
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }
  }

  .upload-position {
    .upload-file-tips {
      font-size: 14px;
      color: $color-text-default-button;
      display: inline-block;
      line-height: 20px;
    }
  }

  .form-item-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-family: "PingFangSC, PingFang SC";

    .checkbox {
      margin-right: 10px;
      // height: 20px;
      // width: 20px;

      .el-radio__label {
        color: $color-text-primary;
        line-height: 32px;
        padding-bottom: 0px;
        font-weight: 800;
        font-size: 14px;
      }
    }

    .label-right {
      color: $color-primary;
      cursor: pointer;
    }

    &.form-item-label-textarea {
      display: flex;
      justify-content: flex-start;
      gap: 10px;
      align-items: flex-start;
    }
  }

  .el-form-item-desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: $color-font-disabled;
    line-height: 32px;
  }

  .el-form-bottom-tips {
    font-size: 13px;
    line-height: 20px;
    color: #606266;
  }

  .el-form-item__content {
    .el-checkbox__inner {
      width: 20px;
      height: 20px;

      &::after {
        height: 10px;
        left: 6px;
      }
    }

    .checkbox-placeholder {
      margin-left: 10px;
    }
  }

  .form-item-text {
    min-height: 44px;
  }

  .rhcn-color-picker {
    position: relative;
    width: 100%;
    max-width: 180px;
    display: flex;

    .el-color-picker {
      width: 100%;
      height: 44px;

      &.el-color-picker--small {
        height: 32px;

        .el-color-picker__trigger {
          height: 32px;
        }
      }

      .el-color-picker__trigger {
        width: 100%;
        height: 44px;
        padding: 0;

        .el-color-picker__color {
          border: 0;
        }
      }

      .el-color-picker__icon {
        display: none;
      }
    }

    .rhcn-color-picker-input {
      position: absolute;
      right: 0;
      top: 0;
      width: 120px;
      pointer-events: none;

      &.small {
        line-height: 32px;
        height: 32px;
        box-sizing: border-box;
      }

      .el-input--small {
        line-height: 32px;

        .el-input__prefix {
          line-height: 32px;
        }
      }

      .el-input__inner {
        border-radius: 0;
      }

      .el-input__prefix {
        left: 20px;
        color: rgba(38, 67, 115, 0.6);
        font-size: 16px;
        line-height: 44px;
      }
    }
  }

  .color-picker-tips {
    margin-top: 6px;
    font-weight: 400;
    font-size: 13px;
    color: #606266;
    line-height: 20px;
  }

  .i-popover {
    .el-popover__reference-wrapper {
      display: flex;
    }

    .icon-tishi003 {
      color: #43618A;
      opacity: 0.7;
      margin-left: 10px;
    }
  }

  .date_time-picker-wrapper {
    padding: 24px;
    background: #F9FAFB;
    border-radius: 8px 8px 8px 8px;
  }
}

.tips-label {
  display: flex;
  align-items: center;

  .icon-wenhao {
    cursor: pointer;
    font-size: 14px;
    margin-left: 8px;
  }
}

.tips-label-box {
  width: 410px;
  padding: 0 13px !important;

  .tips-label-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 8px;
    font-size: 14px;
    font-family: Avenir-Heavy, Avenir;
    // color: $color-text-primary;

    &:last-child {
      margin-bottom: 0;
    }

    .tips-label-key {
      flex-shrink: 0;
      font-weight: 800;
      margin-right: 8px;
    }

    .tips-label-value {
      font-weight: normal;
    }
  }
}

.el-color-picker__panel {
  .el-color-dropdown__btns {
    .el-color-dropdown__value {
      .el-input--mini {
        .el-input__inner {
          height: 32px;
        }
      }
    }

    .el-button--mini {
      height: 32px;
      min-width: 60px;
      font-size: 14px;
    }
  }
}

.info-tips {
  margin: 24px 24px 24px 0;
  font-size: 14px;
  color: $color-text-default-button;
  line-height: 20px;

  .info-tips-item {
    font-family: " Open Sans-Regular";
    font-weight: 400;
    font-size: 14px;
    color: #667085;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>
